import React, { useState, useEffect } from 'react';
import styles from './ProductLabel.module.css';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import Image1 from '../../images/hair-cream.jpg';
import Image2 from '../../images/coconut oil mockup.jpg';
import Image3 from '../../images/massage oil.jpg';
import Image4 from '../../images/soap-mockup.jpg';
import Image5 from '../../images/virgin-coconut-mockup.jpg';
import Image6 from '../../images/honey-mockup.jpg';

import Image7 from '../../images/1kg-Dog-final.jpg';
import Image8 from '../../images/5kg-Puppy-final.jpg';

import Image9 from '../../images/02-11-2025-Vardhini-Large-Ruminants-2.jpg';
import Image10 from '../../images/02-11-2025-Vardhini.jpg';
import Image11 from '../../images/14-02-2024-Pertomeric-Label-4.jpg';

const ProductLabelGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const labels = [
    {
      id: 1,
      title: 'Organic Coffee Blend',
      category: 'Beverage',
      description: 'Hair cream is all natural and doesn\'t contain any chemicals. It contains Virgin coconut oil which helps in fighting dandruff, repair damaged hair, detangle hair, help with dry and frizzy Hair and provides natural bee wax for moisturizing and softening.',
      image: Image1
    },
    {
      id: 2,
      title: 'Honey Harvest',
      category: 'Natural Foods',
      description: 'It is made from Fresh coconut kernel instead of dried ones(Copra) ensuring no fungal infected coconuts are used. It is produced in technical assistance from the Coconut development Board ( Government of India). Produced from locally sourced coconuts for best quality and natural taste.',
      image: Image2
    },
    {
      id: 3,
      title: 'Artisan Olive Oil',
      category: 'Gourmet',
      description: 'An external application of virgin coconut oil helps to relieve eczema. This massage oil helps with dry skin, cracked heels, dark elbows and knees. It contains natural ingredients like Vetiver oil, Neem oil, Jojoba oil, Frankincense and peppermint oil.',
      image: Image3
    },
    {
      id: 4,
      title: 'Craft Beer Collection',
      category: 'Beverage',
      description: 'Our soap is made from extra virgin coconut oil base and has many medicinal properties. It includes honey, grapes, rose, turmeric and neem.',
      image: Image4
    },
    {
      id: 5,
      title: 'Lavender Wellness',
      category: 'Beauty & Spa',
      description: 'Virgin coconut oil doesn\'t involve any chemical process during extraction or purification of it Unlike many other vegetable oil. Thus you re getting a pure, chemical-free oil.',
      image: Image5
    },
    {
      id: 6,
      title: 'Tropical Juice',
      category: 'Beverage',
      description: 'Farmsmojos 100% natural honey undergoes lab tests for added sugar. It crystallizes naturally but can be liquified. Benefits abound, no added sugar guaranteed.',
      image: Image6
    }
  ];

  return (
    <div className={styles.pageWrapper}>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      
      <div className={styles['label-container']}>
        {/* Animated Background */}
        <div className={styles['animated-bg']}>
          <div className={styles['particles-container']}>
            {[...Array(40)].map((_, i) => (
              <div 
                key={i} 
                className={styles['floating-particle']} 
                style={{
                  left: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 15}s`,
                  animationDuration: `${15 + Math.random() * 10}s`
                }} 
              />
            ))}
          </div>
          
          <div className={`${styles['gradient-sphere']} ${styles.sphere1}`} />
          <div className={`${styles['gradient-sphere']} ${styles.sphere2}`} />
          <div className={`${styles['gradient-sphere']} ${styles.sphere3}`} />
          <div className={`${styles['gradient-sphere']} ${styles.sphere4}`} />
          <div className={`${styles['gradient-sphere']} ${styles.sphere5}`} />
          
          <div className={styles['decorative-icons']}>
            <div className={styles['deco-icon']} style={{ top: '12%', left: '8%' }}>🎨</div>
            <div className={styles['deco-icon']} style={{ top: '25%', right: '12%' }}>✨</div>
            <div className={styles['deco-icon']} style={{ bottom: '15%', left: '15%' }}>🖌️</div>
            <div className={styles['deco-icon']} style={{ top: '60%', right: '20%' }}>⭐</div>
            <div className={styles['deco-icon']} style={{ bottom: '30%', right: '8%' }}>💫</div>
          </div>
        </div>

        <div className={styles['content-container']}>
          {/* Hero Section */}
          <div className={styles['hero-section']}>
            <h1 className={styles['main-title']}>
              <span className={styles['title-part']}>Product</span>
              <span className={styles['title-part']}>Label</span>
              <span className={styles['title-part']}>Design</span>
            </h1>
            <div className={styles['title-underline']} />
            <p className={styles['hero-subtitle']}>Crafting Visual Identities That Tell Your Brand Story</p>
          </div>

          {/* Project Info Section */}
          <div className={styles['project-info-section']}>
            <div className={styles['project-info-grid']}>
              <div className={styles['info-item']}>
                <h3 className={styles['info-label']}>Work</h3>
                <p className={styles['info-value']}>Product Cover Design</p>
              </div>
              <div className={styles['info-item']}>
                <h3 className={styles['info-label']}>Year</h3>
                <p className={styles['info-value']}>2022</p>
              </div>
              <div className={styles['info-item-full']}>
                <p className={styles['info-description']}>
                  Designing Gemma Naturals product stickers using Photoshop, Illustrator, and CorelDRAW to ensure branding consistency and quality. Overseeing product care and distribution now managed by FarmsMojo, maintaining standards and brand integrity.
                </p>
              </div>
            </div>
          </div>

          {/* Labels Grid */}
          <div className={styles['labels-grid']}>
            {labels.map((label, index) => (
              <div
                key={label.id}
                className={styles['label-card']}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div
                  className={styles['label-preview']}
                  onClick={() => setSelectedImage(label.image)}
                >
                  <img 
                    src={label.image} 
                    alt={label.title} 
                    style={{
                      width: '100%',
                      height: '350px',
                      objectFit: 'cover',
                      borderRadius: '16px'
                    }}
                  />
                </div>

                <div className={styles['label-info']}>
                  
                  <p className={styles['label-description']}>{label.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Project Info Section */}
          <div className={styles['project-info-section']}>
            <div className={styles['project-info-grid']}>
              <div className={styles['info-item']}>
                <h3 className={styles['info-label']}>Work</h3>
                <p className={styles['info-value']}>Pet Food Packaging</p>
              </div>
              <div className={styles['info-item']}>
                <h3 className={styles['info-label']}>Year</h3>
                <p className={styles['info-value']}>2023</p>
              </div>
              <div className={styles['info-item-full']}>
                <p className={styles['info-description']}>
                  Premium pet food packaging design featuring modern aesthetics and clear nutritional information for optimal brand presentation.
                </p>
              </div>
            </div>
          </div>

          {/* Two Images Row */}
          <div className={styles['two-images-row']}>
            <div className={styles['image-item']} onClick={() => setSelectedImage(Image7)}>
              <img 
                src={Image7} 
                alt="Pet Food Package 1" 
                className={styles['grid-img']}
              />
            </div>
            <div className={styles['image-item']} onClick={() => setSelectedImage(Image8)}>
              <img 
                src={Image8} 
                alt="Pet Food Package 2" 
                className={styles['grid-img']}
              />
            </div>
          </div>

          {/* Label Description for Two Images */}
          <div className={styles['label-description-section']}>
            <p className={styles['label-description']}>
              Premium pet food packaging design featuring modern aesthetics and clear nutritional information for optimal brand presentation and customer appeal.
            </p>
          </div>

          {/* Three Images Row */}
          <div className={styles['three-images-row']}>
            <div className={styles['image-item']} onClick={() => setSelectedImage(Image9)}>
              <img src={Image9} alt="Label Design 1" className={styles['grid-img']} />
            </div>
            <div className={styles['image-item']} onClick={() => setSelectedImage(Image10)}>
              <img src={Image10} alt="Label Design 2" className={styles['grid-img']} />
            </div>
            <div className={styles['image-item']} onClick={() => setSelectedImage(Image11)}>
              <img src={Image11} alt="Label Design 3" className={styles['grid-img']} />
            </div>
          </div>

          {/* Label Description for Three Images */}
          <div className={styles['label-description-section']}>
            <p className={styles['label-description']}>
              Professional label designs showcasing versatile branding solutions with attention to detail and visual impact across different product categories.
            </p>
          </div>
        </div>

        {/* Image Modal */}
        {selectedImage && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.95)',
              backdropFilter: 'blur(20px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              animation: 'fadeIn 0.3s ease'
            }}
            onClick={() => setSelectedImage(null)}
          >
            <div 
              style={{
                position: 'relative',
                maxWidth: '90vw',
                maxHeight: '90vh',
                background: 'linear-gradient(145deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                backdropFilter: 'blur(30px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '20px',
                padding: '20px',
                boxShadow: '0 25px 50px rgba(0,0,0,0.5)'
              }}
              onClick={e => e.stopPropagation()}
            >
              <button 
                style={{
                  position: 'absolute',
                  top: '-15px',
                  right: '-15px',
                  background: 'linear-gradient(135deg, #ff6b6b, #ee5a6f)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  color: '#fff',
                  fontSize: '18px',
                  cursor: 'pointer',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  transition: 'all 0.3s',
                  zIndex: 1001,
                  boxShadow: '0 8px 20px rgba(255,107,107,0.4)'
                }}
                onClick={() => setSelectedImage(null)}
              >
                ×
              </button>
              <img 
                src={selectedImage} 
                alt="Product Label" 
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  objectFit: 'contain',
                  borderRadius: '15px',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
                }}
              />
            </div>
          </div>
        )}
      </div>
      
      <div className={styles.footerOverride}>
        <Footer mode={mode} />
      </div>
    </div>
  );
};

export default ProductLabelGallery;